<template>
  <v-sheet class="py-10 py-md-13 py-lg-16" min-height="100%" color="#FBF9F4">
    <TitleWidget class="text-center"> Produtos </TitleWidget>

    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container class="py-0" v-if="!loading">
        <div v-if="items.length" class="mt-10 grid-list">
          <template v-for="(item, keyItems) in items">
            <ProductCard :key="keyItems" v-bind="item" />
          </template>
        </div>

        <v-alert v-else prominent class="secondary white--text mt-10">
          <v-row justify-sm="space-between" align="center">
            <v-col class="d-flex align-center" cols="12" sm="auto">
              <v-icon class="mr-2" size="30" color="white">
                fa-info-circle
              </v-icon>
              <span class="font-secondary"> Nenhum produto encontrado. </span>
            </v-col>
            <v-col cols="12" sm="auto">
              <v-btn
                color="primary lighten-3 secondary--text"
                to="/produtos"
                :width="xsOnly ? '100%' : 'auto'"
              >
                <span class="font-secondary">Todos os Produtos</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-container>
    </transition>
  </v-sheet>
</template>

<script>
import { formatToURL } from "../utils/formatToURL";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import ProductCard from "../components/cards/ProductCard.vue";

const _config = {
  mod: "products",
  path: "/produtos",
  itemsPerPage: 24,
  returnTotalItems: 1,
};

export default {
  data: () => ({
    loading: true,
    items: [],
    itemsPerPage: _config.itemsPerPage,
    returnTotalItems: _config.returnTotalItems,
    totalItems: 0,
  }),
  created() {
    this.get();
  },
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    get() {
      this.loading = true;

      const params = {
        itemsPerPage: this.itemsPerPage,
        returnTotalItems: this.returnTotalItems,
        page: this.page,
      };

      if (this.$route.query.categoria)
        params.category = Number(
          this.$route.query.categoria.replace(/^.*-([0-9]+)$/, "$1")
        );

      if (this.$route.query.subcategoria)
        params.subcategory = Number(
          this.$route.query.subcategoria.replace(/^.*-([0-9]+)$/, "$1")
        );

      if (this.$route.query.ocasiao)
        params.occasion = Number(
          this.$route.query.ocasiao.replace(/^.*-([0-9]+)$/, "$1")
        );

      if (this.$route.query.q) params.search = this.$route.query.q;

      this.$rest(_config.mod)
        .get({ params })
        .then((data) => {
          let items = [];

          if (this.returnTotalItems) {
            items = data.list;
            this.totalItems = data.totalItems;
          } else {
            items = data;
          }

          this.items = items.map(
            ({ id, img, title, price, category, subcategory }) => ({
              img,
              title,
              price: price ? parseFloat(price) : 0,
              category,
              subcategory,
              to: `${_config.path}/${formatToURL(title)}-${id}`,
            })
          );
        })
        .then(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.get();
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    ProductCard,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 62px;
  grid-template-columns: repeat(4, minmax(0, 1fr));

  @media screen and (max-width: 960px) {
    gap: 30px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 600px) {
    gap: 30px 10px;
  }
}
</style>
